const colors = {
  white: "#F0F4EF",
  blue: "#344966",
  blueLight: "#B4CDED",
  blueLight2: "#0085ff66",
  darkBlue: "#05469d70",
  black: "#0D1821",
  grey: "rgba(0, 0, 0, 0.54)",
};

export const { white, blue, blueLight, blueLight2, darkBlue, black, grey } =
  colors;
